import React from "react";

const RecordPause = () => {
  return (
    <svg
      width="1em"
      height="1em"
      fontSize="inherit"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.475 0 0 4.475 0 10C0 15.525 4.475 20 10 20C15.525 20 20 15.525 20 10C20 4.475 15.525 0 10 0ZM8.9 12.5C8.9 13.125 8.4 13.6 7.8 13.6C7.175 13.6 6.7 13.1 6.7 12.5V7.5C6.675 6.9 7.175 6.4 7.775 6.4C8.4 6.4 8.9 6.9 8.9 7.5V12.5ZM13.325 12.5C13.325 13.125 12.825 13.6 12.225 13.6C11.6 13.6 11.125 13.1 11.125 12.5V7.5C11.1 6.9 11.6 6.4 12.2 6.4C12.825 6.4 13.325 6.9 13.325 7.5V12.5Z"
        fill="#EC4F3C"
      />
    </svg>
  );
};

export default RecordPause;
